import React from 'react';

const PrivacyPolicy = () => {
    return (
        <div className="container pb-5" style={{ maxWidth: '800px', marginTop: '75px' }}>
            <h1 className="mb-4">Privacy Policy</h1>
            <p className="text-muted mb-4">Last updated: January 2025</p>

            <section className="mb-4">
                <h2 className="h4">Introduction</h2>
                <p>
                    PilotHelper LLC ("we," "our," or "us") respects your privacy and is committed to protecting
                    your personal data. This privacy policy explains how we collect, use, and safeguard your
                    information when you use our website and services.
                </p>
            </section>

            <section className="mb-4">
                <h2 className="h4">Information We Collect</h2>
                <p>We may collect the following types of information:</p>
                <ul>
                    <li><strong>Account Information:</strong> When you sign up, we collect your name, email address, and authentication data (via email/password or Google Sign-In).</li>
                    <li><strong>Course Progress:</strong> We track your progress through our training courses to provide a personalized learning experience.</li>
                    <li><strong>Contact Information:</strong> When you contact us, we collect your name, email, phone number, and message content.</li>
                    <li><strong>Usage Data:</strong> We may collect information about how you interact with our website.</li>
                </ul>
            </section>

            <section className="mb-4">
                <h2 className="h4">How We Use Your Information</h2>
                <p>We use your information to:</p>
                <ul>
                    <li>Provide and maintain our services</li>
                    <li>Create and manage your account</li>
                    <li>Track your course progress and issue certificates</li>
                    <li>Respond to your inquiries and provide customer support</li>
                    <li>Send important updates about our services</li>
                    <li>Improve our website and services</li>
                </ul>
            </section>

            <section className="mb-4">
                <h2 className="h4">Third-Party Services</h2>
                <p>We use the following third-party services:</p>
                <ul>
                    <li><strong>Firebase (Google):</strong> For authentication and data storage</li>
                    <li><strong>Google Sign-In:</strong> For convenient account authentication</li>
                    <li><strong>EmailJS/Brevo:</strong> For sending emails</li>
                </ul>
                <p>These services have their own privacy policies governing how they handle your data.</p>
            </section>

            <section className="mb-4">
                <h2 className="h4">Data Security</h2>
                <p>
                    We implement appropriate security measures to protect your personal information.
                    However, no method of transmission over the internet is 100% secure, and we cannot
                    guarantee absolute security.
                </p>
            </section>

            <section className="mb-4">
                <h2 className="h4">Your Rights</h2>
                <p>You have the right to:</p>
                <ul>
                    <li>Access the personal data we hold about you</li>
                    <li>Request correction of inaccurate data</li>
                    <li>Request deletion of your data</li>
                    <li>Withdraw consent for data processing</li>
                </ul>
                <p>To exercise these rights, please contact us at <a href="mailto:contact@pilothelper.com">contact@pilothelper.com</a>.</p>
            </section>

            <section className="mb-4">
                <h2 className="h4">Cookies</h2>
                <p>
                    We use cookies and similar technologies to maintain your session and improve your
                    experience. You can control cookies through your browser settings.
                </p>
            </section>

            <section className="mb-4">
                <h2 className="h4">Children's Privacy</h2>
                <p>
                    Our services are not intended for children under 13 years of age. We do not knowingly
                    collect personal information from children under 13.
                </p>
            </section>

            <section className="mb-4">
                <h2 className="h4">Changes to This Policy</h2>
                <p>
                    We may update this privacy policy from time to time. We will notify you of any changes
                    by posting the new policy on this page and updating the "Last updated" date.
                </p>
            </section>

            <section className="mb-4">
                <h2 className="h4">Contact Us</h2>
                <p>
                    If you have questions about this privacy policy, please contact us at:
                </p>
                <p>
                    <strong>Email:</strong> <a href="mailto:contact@pilothelper.com">contact@pilothelper.com</a>
                </p>
            </section>
        </div>
    );
};

export default PrivacyPolicy;
